<template>
    <div class="classic-book-website">
      <!-- 第一区域：顶部公司信息 -->
      <header class="header-section">
        <div class="container header-container">
          <div class="logo-area">
            <div class="logo" style="cursor: pointer;" @click="goBackPage">
              <img width="75" height="75" src="../../assets/bookpic/newlogo.png" alt="Logo" @error="handleImageError">
            </div>
            <div class="site-name">
              <h1>墨庫
                <span class="english-part">
                  <span class="moku">·MoKu</span>
                  <span class="infinity">∞</span>
                </span>
              </h1>
              <p>文献档案智能检索、阅读与研究平台</p>
            </div>
          </div>

          <div class="contact-info">
            <p style="cursor: pointer;" @click="showVipBook" v-if="isVipUser == 1 && (!isMobile)"><i class="fas fa-user"></i> 个人中心：我的书籍</p>
            <p><i class="fas fa-phone-alt"></i> 联系电话：13601121024</p>
            <p><i class="fas fa-envelope"></i> 邮箱：chp1960@163.com</p>
          </div>
        </div>
      </header>

      <!-- 我的书籍弹出层 -->
      <div class="modal-overlay" v-if="showTagsModal" @click="showTagsModal = false">
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <h2 class="modal-title">我的书籍</h2>
            <button class="close-btn" @click="showTagsModal = false">&times;</button>
          </div>
          <div class="modal-tags" v-if="isHaveBook">
            <div
              v-for="tag in additionalTags"
              :key="tag"
              class="modal-tag"
              @click="handleModalTagClick(tag)"
            >
              {{ tag }}
            </div>
          </div>

          <div class="modal-tags" v-if="!isHaveBook">
            暂无书籍数据。
          </div>
        </div>
      </div>

    </div>
  </template>
  
  <script>
  import { getUserInfo, getVipuserBook } from '../../api/home'
  import axios from 'axios';

  export default {
    name: 'ClassicBookWebsite',
    data() {
      return {
        searchKeyword: '',
        isMobile: false,
        windowWidth: 0,
        showMobileCategories: false,
        theUserInfo: {},
        isVipUser: 0,   //是否vip用户，0：访客，1：Vip用户
        isHaveBook: false,
        
        showTagsModal: false,
        additionalTags: [],    //书籍名称数组
      }
    },

    //初始化获取网络数据
    created() {
      this.windowWidth = window.innerWidth;
      this.isMobile = this.windowWidth <= 768;

      // this.GetUserInfo();   //20260315 remark,用下面的区间代码代替
      //20260315，vip用户身份的判断处理*********************************************************begin
      localStorage.setItem("isForbidUser","1");   //默认账户未禁用
      if(this.isMobile){       //移动手机访问用户一定非vip用户
        this.theUserInfo = {};
        this.theUserInfo.status = "1";
        this.isVipUser = 0;
        localStorage.setItem("isVipUser",this.isVipUser);
        localStorage.setItem("theUserInfo",JSON.stringify(this.theUserInfo));
        localStorage.setItem("isForbidUser",this.theUserInfo.status);   //是否被禁用的用户

        localStorage.setItem("UserOfPhoneHash","0");
      }
      else{
        let noIsVipInitUrl = true;
        //解析网址，判断是否需要进行vip用户的客户端软件判断
        let queryString = window.location.search.slice(1);

        console.log("20260317===" + queryString);

        if(queryString != '' && queryString != null && queryString != undefined){
          let queryArr = [];
          queryArr = queryString.split("&");
          if(queryArr.length == 2){
            if(queryArr[0].substring(0,2) == 'v=' && queryArr[1].substring(0,2) == 'p='){
              console.log("20260317,该输入浏览器地址是图库初始化地址，连接客户端图库软件判断用户身份");
              //将用户输入的图库初始网址保存
              localStorage.setItem("inputTkNetUrl",window.location.href);

              noIsVipInitUrl = false;
              let phonehash = queryArr[0].substring(2);
              let p_wayvalue = queryArr[1].substring(2);
              localStorage.setItem("UserOfPhoneHash",phonehash);

              let queryParams = {};
              queryParams.phonehash = phonehash;
              getUserInfo(queryParams).then(response => {
                  this.isVipUser = response.data.maprowdata.isvipuser;
                  localStorage.setItem("isVipUser",this.isVipUser);

                  console.log("20260317,服务器第一次判断是否为vip用户===" + this.isVipUser);

                  this.theUserInfo = response.data.rows[0];
                  // localStorage.setItem("theUserInfo",this.theUserInfo);
                  localStorage.setItem("theUserInfo",JSON.stringify(this.theUserInfo));
                  if(this.theUserInfo != undefined){
                    localStorage.setItem("isForbidUser",this.theUserInfo.status);   //是否被禁用的用户
                  }

                  if(this.isVipUser == 1){    //后端判断后可能是vip用户，需要根据客户端图库软件再判断身份
                    this.isVipUser = 0;
                    
                    // 20260402 remark，实现无本地客户端功能
                    // if(p_wayvalue == '0'){    //确定的非vip用户，普通用户
                    //   this.isVipUser = 0;
                    //   localStorage.setItem("isVipUser",this.isVipUser);
                    // }
                    // else{      //需要调用客户端图库软件判断vip身份


                    let port = 10088;
                    if(p_wayvalue == '1'){
                      port = 10088;
                    }
                    else if(p_wayvalue == '2'){
                      port = 20088;
                    }
                    else if(p_wayvalue == '3'){
                      port = 30088;
                    }
                    else if(p_wayvalue == '4'){
                      port = 40088;
                    }
                    else if(p_wayvalue == '5'){
                      port = 50088;
                    }
                    let clientUrl = 'https://localhost:' + port + '/?' + 'a=' + this.theUserInfo.phonemd5hash;

                    // 20260402 add，实现无本地客户端功能
                    if(p_wayvalue == '0'){
                      // 获取完整的源（协议 + 域名 + 端口）
                      const fullOrigin = window.location.origin;
                      clientUrl = fullOrigin + '/vipimg/?' + 'a=' + this.theUserInfo.phonemd5hash;
                    }

                    console.log("20260317,客户端vip判断网址===" + clientUrl);
                    this.judgeUserIsVip(clientUrl)
                      .then(result => {
                        let viptype = result;
                        if(viptype){
                          this.isVipUser = 1;
                          let pictureStoreUrlFix = 'https://localhost:' + port + '/?' + 'p=';

                          // 20260402 add，实现无本地客户端功能
                          if(p_wayvalue == '0'){
                            const fullOrigin1 = window.location.origin;
                            pictureStoreUrlFix = fullOrigin1 + '/vipimg/?' + 'p=';
                          }

                          localStorage.setItem("pictureStoreUrlFix",pictureStoreUrlFix);
                          console.log("20260317,图库图片的网址===" + pictureStoreUrlFix);
                        }
                        else{
                          this.isVipUser = 0;
                        }
                        localStorage.setItem("isVipUser",this.isVipUser);
                      });

                    // }    // 20260402 remark，实现无本地客户端功能

                  }

              })
            }
          }
        }
        else{    //如果用户输入首页网址，没有带入参数，则按照访客判断处理
          this.theUserInfo = {};
          this.theUserInfo.status = "1";
          this.isVipUser = 0;
          localStorage.setItem("isVipUser",this.isVipUser);
          localStorage.setItem("theUserInfo",JSON.stringify(this.theUserInfo));
          localStorage.setItem("isForbidUser",this.theUserInfo.status);   //是否被禁用的用户

          if (localStorage.getItem("inputTkNetUrl") !== null){
            localStorage.removeItem("inputTkNetUrl");
          }
        }

        if(noIsVipInitUrl){   //非图库初始的url地址，从本地缓存中获取与vip用户相关的属性信息
          if (localStorage.getItem("isVipUser") !== null) {
            this.isVipUser = localStorage.getItem("isVipUser");
            if(this.isVipUser == 1){
              this.theUserInfo = JSON.parse(localStorage.getItem("theUserInfo"));
              this.theUserInfo.status = localStorage.getItem("isForbidUser");
            }
            else{
              this.theUserInfo = {};
              this.theUserInfo.status = "1";
            }
          }
          else{
            this.theUserInfo = {};
            this.theUserInfo.status = "1";
            this.isVipUser = 0;
          }
        }

      }
      //20260315，vip用户身份的判断处理*********************************************************end

    },
    computed: {

    },
    mounted() {

    },
    beforeDestroy() {
    
    },
    methods: {
      // 获取当前路由信息
      getCurrentRoute() {
        const route = this.$route;
        return route.name;
      },

      // 获取用户的信息，方法备用，20260315
      /*
      GetUserInfo(){
        let queryParams = {};
        localStorage.setItem("isForbidUser","1");   //默认账户未禁用
        getUserInfo(queryParams).then(response => {
            this.theUserInfo = response.data.rows[0];
            this.isVipUser = response.data.maprowdata.isvipuser;
            localStorage.setItem("isVipUser",this.isVipUser);
            localStorage.setItem("theUserInfo",this.theUserInfo);

            //20260315 modify
            //localStorage.setItem("isForbidUser",this.theUserInfo.status);   //是否被禁用的用户
            if(this.theUserInfo != undefined){
              localStorage.setItem("isForbidUser",this.theUserInfo.status);   //是否被禁用的用户
            }
        })
      },
      */

      handleSearch() {
        if (this.searchKeyword.trim()) {
          /* this.$message({
            message: `正在搜索: ${this.searchKeyword}`,
            type: 'info'
          }) */
          
          let _self = this
          _self.$router.push({path:'/searchpage',query: {type:'1'}})
        } else {
          this.$message({
            message: '请输入搜索关键词',
            type: 'warning'
          })
        }
      },
    
      handleImageError(e) {
        console.error('Logo图片加载失败')
        e.target.style.display = 'none'
      },
    
      // 返回上级界面
      goBackPage(){
        let pagename = this.getCurrentRoute()
        if(pagename != 'hoem'){   //非首页界面，才返回首页界面
          let _self = this
          //20260323,
          // _self.$router.push({path:'/'})
          if(this.isMobile){
            _self.$router.push({path:'/'})
          }
          else{
            if (localStorage.getItem("inputTkNetUrl") !== null){
              window.location.href = localStorage.getItem("inputTkNetUrl");
            }
            else{
              _self.$router.push({path:'/'})
            }
          }
        }
      },

      showVipBook(){
        // 方案一：我的书籍为列表对话框
        /*
        this.additionalTags = [];
        this.showTagsModal = true;
        if(this.isVipUser == 1){
          let queryParamsBook = {};
          queryParamsBook.seriesno = this.theUserInfo.booksid;
          getVipuserBook(queryParamsBook).then(response => {
            this.additionalTags = response.data.rows;
            this.isHaveBook = false;
            if(this.additionalTags.length > 0){
              this.isHaveBook = true;
            }
          })
        }
        */

        // 方案二：我的书籍为单独页面展示, 20260316
        if(this.theUserInfo.booksid == '' || this.theUserInfo.booksid == null || this.theUserInfo.booksid == undefined){
          this.$message({
            message: '您目前没有分配书籍，请通过电话或邮件联系我们。',
            type: 'warning'
          })
          return;
        }
        localStorage.setItem("myVipBookSeriesId", this.theUserInfo.booksid);
        window.location.href = `/recommandwill?type=3&classname=我的书籍`;
      },

      //执行客户端图库软件的调用，最终判断用的vip身份
      async judgeUserIsVip(clientUrl) {
        let result = false;
        try {
          const response = await axios.get(clientUrl);
          // axios 会自动将响应转为字符串（如果是纯文本）
          result = String(response.data).trim().toLowerCase() === 'true';
        } catch (error) {
          console.log("20260317--------------");
          console.error('本地电脑未安装客户端软件，或客户端软件未启动', error);
          
          result = false;     //20260316，正式模式,continue!!!!!!!!!!!!!!
          // result = true;   //20260316，开发模式,本地电脑未安装图库客户端软件，判断为vip用户进行测试 
        }
        return result;
      },

    }
  }
  </script>
  
  <style scoped>
  /* 引入外部字体和图标库 20260105*/
  @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');
  @import url('https://fonts.googleapis.com/css2?family=Ma+Shan+Zheng&family=Noto+Serif+SC:wght@400;600;700&display=swap');

  /* 基础样式重置与古典风格定义 */
  * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
  }
  
  body {
      font-family: 'Noto Serif SC', serif;
      line-height: 1.6;
      color: #5c3a21;
      background-color: #f5f0e6; /* 古典纸张背景色 */
      background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%239C8B7E' fill-opacity='0.08' fill-rule='evenodd'/%3E%3C/svg%3E");
      min-height: 100vh;
      overflow-x: hidden;
  }
  
  .container {
      width: 100%;
      /* max-width: 1200px; 20260107，增加界面的宽度*/
      max-width: 1500px;
      margin: 0 auto;
      padding: 0 15px;
  }
  
  /* 古典风格边框与阴影 */
  .classic-border {
      border: 1px solid #c9b18b;
      border-radius: 3px;
      box-shadow: 0 4px 8px rgba(92, 58, 33, 0.1);
  }
  
  .classic-bg {
      background-color: #fffaf0;
      border: 1px solid #d4c4a8;
  }
  
  /* 第一区域：顶部公司信息 */
  .header-section {
      background-color: #8b4513; /* 古典深棕色 */
      color: #f5deb3;
      padding: 19px 0;
      border-bottom: 3px solid #d2691e;
  }
  
  .header-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
  }
  
  .logo-area {
      display: flex;
      align-items: center;
  }
  
  .logo {
      width: 60px;
      height: 60px;
      background-color: #f5deb3;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 15px;
      border: 2px solid #d2691e;
      overflow: hidden;
  }
  
  .logo img {
      width: 100%;
      height: 100%;
      object-fit: contain;
  }
  
  .site-name h1 {
      font-family: 'Noto Serif SC', serif;
      font-size: 1.8rem;
      color: #f5deb3;
      letter-spacing: 2px;
      text-shadow: 1px 1px 2px #5c3a21;
  }

  .site-name h1 span{
    font-size: 1.6rem;
  }
  .english-part {
    display: inline-flex;
    align-items: flex-end; /* 确保MoKu和∞底部对齐 */
  }
  .moku {
    font-family: 'Noto Serif SC', serif;
    font-weight: 700;
  }
  .infinity {
    font-size: 1.2em; /* 稍微调整∞的大小 */
    margin-left: 2px; /* 添加一点间距 */
    line-height: 1; /* 防止行高影响对齐 */
  }
  
  .site-name p {
      font-size: 0.9rem;
      color: #e6d3b3;
      margin-top: 3px;
      font-family: 'Noto Serif SC', serif;
  }
  
  .contact-info {
      text-align: right;
  }
  
  .contact-info p {
    margin-bottom: 5px;
    font-size: 0.95rem;
    text-align: right; /* 确保每个段落都右对齐 */
    font-family: 'Noto Serif SC', serif;
  }




  /* 弹出层样式 */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background-color: #fffaf0;
    border-radius: 8px;
    width: 90%;
    max-width: 700px;
    max-height: 80vh;
    overflow-y: auto;
    padding: 30px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    border: 2px solid #c9b18b;
    position: relative;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 2px solid #d4c4a8;
  }

  .modal-title {
    font-family: 'Noto Serif SC', serif;
    font-size: 1.8rem;
    color: #8b4513;
    letter-spacing: 1px;
  }
  
  .close-btn {
  background: none;
  border: none;
  font-size: 1.8rem;
  color: #8b4513;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.3s;
}

.close-btn:hover {
  background-color: rgba(139, 69, 19, 0.1);
}

.modal-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 25px;
}

.modal-tag {
  background-color: #f9f5eb;
  border: 1px solid #c9b18b;
  padding: 12px 20px;
  border-radius: 25px;
  font-size: 1rem;
  color: #5c3a21;
  cursor: pointer;
  transition: all 0.3s;
  flex: 1;
  min-width: 200px;
  text-align: center;
}

.modal-tag:hover {
  background-color: #8b4513;
  color: #f5deb3;
  border-color: #8b4513;
  transform: translateY(-2px);
}





  /* 响应式设计 */
  @media (max-width: 1200px) {
      .books-grid-five {
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
      }
  }
  
  @media (max-width: 992px) {
      .books-grid-five {
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
      }

      .modal-content {
        width: 95%;
        padding: 20px;
      }

      .modal-tag {
        min-width: 150px;
      }
      
      
  }
  
  @media (max-width: 768px) {
      .header-container {
          flex-direction: column;
          align-items: flex-start;
      }
      
      .contact-info {
          text-align: left;
          margin-top: 15px;
      }
      
      .site-name h1 {
          font-size: 1.5rem;
      }

      /* 20260108 */
      .site-name h1 span{
        font-size: 1.3rem;
      }
      .site-name h1 span .infinity {
        font-size: 1.1em;
      }
      .contact-info p {
        text-align: left;
      }

      .modal-content {
        width: 98%;
        padding: 15px;
      }
      
      .modal-tags {
        gap: 10px;
      }
      
      .modal-tag {
        min-width: 120px;
        padding: 10px 15px;
        font-size: 0.9rem;
      }
      
      .modal-title {
        font-size: 1.5rem;
      }
      
  }
  
  @media (max-width: 576px) {
      .logo {
          width: 50px;
          height: 50px;
      }
      .contact-info p {
          font-size: 0.85rem;
      }

      .site-name h1 {
          font-size: 1.3rem;
      }

      /* 20260108 */
      .site-name h1 span{
        font-size: 1.2rem;
      }
      .site-name h1 span .infinity {
        font-size: 1.1em;
      }
      .contact-info p {
        text-align: left;
      }
      
  }
  
  @media (max-width: 400px) {
      /* 20260108 */
      .site-name h1 span{
        font-size: 1.2rem;
      }
      .site-name h1 span .infinity {
        font-size: 1.1em;
      }
      .contact-info p {
        text-align: left;
      }

  }
  
  /* 古典印章样式 */
  .seal-style {
      display: inline-block;
      padding: 5px 10px;
      background-color: #8b4513;
      color: #f5deb3;
      border-radius: 3px;
      font-size: 0.8rem;
      font-family: 'Noto Serif SC', serif;
      letter-spacing: 1px;
  }
  </style>


// WEBPACK FOOTER //
// src/views/atop/index.vue